<script setup lang="ts">
import SharedBlockHeading from './heading.vue'
import SharedBlockRichText from './rich-text.vue'
import SharedBlockImages from './images.vue'
import SharedBlockSummary from './summary.vue'
import SharedBlockItem from './item.vue'
import SharedBlockDownloads from './downloads.vue'
import SharedBlockPersonList from './person-list.vue'
import SharedBlockLinks from './links.vue'
import SharedBlockMediaArray from './media-array.vue'
import SharedBlockEvents from './events.vue'

const props = defineProps({
  block: {
    type: Object,
    required: true,
  },
  noHorizontalPadding: {
    type: Boolean,
    default: false,
  },
})

const componentMap: Record<string, Component> = {
  heading: SharedBlockHeading,
  'rich-text': SharedBlockRichText,
  images: SharedBlockImages,
  summary: SharedBlockSummary,
  item: SharedBlockItem,
  downloads: SharedBlockDownloads,
  'person-list': SharedBlockPersonList,
  links: SharedBlockLinks,
  'media-array': SharedBlockMediaArray,
  events: SharedBlockEvents,
}

const blockComponent = computed(() => componentMap[props.block.blockType] ?? null)

const alignClass = computed(() => props.block.rightAlign ? 'mx-auto' : undefined)

// an editor-set `anchor` (payload/src/fields/shared/anchor.ts) becomes the
// element id so a link hash can target the block; otherwise the block's own id
const elementId = computed(() => props.block.anchor || props.block.id)
</script>

<template>
  <template v-if="blockComponent">
    <component
      :is="blockComponent"
      :id="elementId"
      :block="block"
      :no-horizontal-padding="noHorizontalPadding"
      :class="[alignClass, 'last:mb-0']"
      v-bind="$attrs"
      :data-type="props.block.blockType"
    />
  </template>
</template>
